export const MATTRACKERAPIConstants = {
  GET_DASHBOARD: 'getDashboard',
  ADDMATREQUEST: 'addMatRequest',
  GETLOOKUPDATA: 'getLookupData',
  GET_USERS: 'getUsers',
  GET_USER_BY_ID: 'getUserById',
  ADD_USER: 'addUser',
  UPDATE_USER: 'updateUser',
  DELETE_USER: 'deleteUser',
  GET_USER_INFO: 'getUserInfo',
  // Storage Hub endpoints
  GET_STORAGE_HUBS: 'getStorageHubs',
  ADD_STORAGE_HUB: 'addStorageHub',
  UPDATE_STORAGE_HUB: 'updateStorageHub',
  GET_LOOKUP_DATA: 'getLookupData',

  // Attachment API endpoints
  PRESIGN_ATTACHMENT: 'presignAttachment',
  ADD_ATTACHMENT: 'addAttachment',
  GET_ATTACHMENTS_BY_REQUEST: 'getAttachmentsByRequest',
  DOWNLOAD_ATTACHMENT: 'downloadAttachment',
  DELETE_ATTACHMENT: 'deleteAttachment',

  // Status transition endpoint
  UPDATE_REQUEST_STATUS: 'updateRequestStatus',

  // Substation suggestions (autocomplete)
  GET_SUBSTATION_SUGGESTIONS: 'getSubstationSuggestions',

  // Notes endpoints
  ADD_NOTES: 'addNotes',
  GET_NOTES: 'getNotes',

  // â”€â”€ Mat Allocation endpoints â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** POST /matAllocationSave — saves allocation without changing status */
  MAT_ALLOCATION_SAVE: 'matAllocationSave',
  /** POST /matAllocationMoveToActive — transitions Ready → Active */
  MAT_ALLOCATION_MOVE_TO_ACTIVE: 'matAllocationMoveToActive',
  /** GET /getMatAllocationsByRequestId?requestId=<internalSeq> */
  GET_MAT_ALLOCATIONS_BY_REQUEST: 'getMatAllocationsByRequestId',
  /** GET /getActivePageSourceLocations?requestId=<requestId> — Active-page transfer table */
  GET_ACTIVE_PAGE_SOURCE_LOCATIONS: 'getActivePageSourceLocations',
  /** POST /matDelivered — marks mats as delivered for an active request */
  MAT_DELIVERED: 'matDelivered',
  /** POST /reviseMatAllocation — revises an active mat request */
  REVISE_MAT_ALLOCATION: 'reviseMatAllocation',

  // â”€â”€ Release endpoints â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /getReleasePageData?requestId=<id> — inUseQty, existing entries, available locations */
  GET_RELEASE_PAGE_DATA: 'getReleasePageData',
  /** POST /initRelease — auto-creates rental return entries (idempotent) */
  INIT_RELEASE: 'initRelease',
  /** POST /transferToLocation — manual transfer to hub/rental */
  TRANSFER_TO_LOCATION: 'transferToLocation',
  /** POST /confirmReleaseTransfer — completes a staged transfer (In_Transit → target bucket) */
  CONFIRM_RELEASE_TRANSFER: 'confirmReleaseTransfer',
  /** POST /releaseForFutureProject — In_Use → Released at same location */
  RELEASE_FOR_FUTURE_PROJECT: 'releaseForFutureProject',
  /** POST /recallFromFutureProject — reduces future-project released qty; soft-deletes at 0 */
  RECALL_FROM_FUTURE_PROJECT: 'recallFromFutureProject',
  /** POST /delRelTransfer — deletes a release transfer entry */
  DEL_REL_TRANSFER: 'delRelTransfer',

  // â”€â”€ Email endpoint â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** POST /addEmail — sends a vendor email */
  ADD_EMAIL: 'addEmail',
  /** GET /getEmailTrail?requestId=<id> — returns full email history for a request */
  GET_EMAIL_TRAIL: 'getEmailTrail',

  // â”€â”€ Date Revision endpoints â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** POST /reviseDates — creates next date revision for an Active request */
  REVISE_DATES: 'reviseDates',
  /** GET /getDateRevisions?matRequestId=<internalSeq> — returns full revision history */
  GET_DATE_REVISIONS: 'getDateRevisions',

  // â”€â”€ Project suggestions (autocomplete) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /getProjectSuggestions?q=<query>&limit=<n> */
  GET_PROJECT_SUGGESTIONS: 'getProjectSuggestions',

  // â”€â”€ POC search endpoint â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /searchPoc?q=<term> — search users with role POC by name or email */
  SEARCH_POC: 'searchPoc',

  // â”€â”€ Cancel / Delete request endpoint â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** POST /delMatReq — cancels/deletes a Draft or Created mat request */
  DEL_MAT_REQ: 'delMatReq',

  // â”€â”€ Duplicate Request Check endpoint â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /checkDuplicateRequest?substationId=&excludeRequestId= */
  CHECK_DUPLICATE_REQUEST: 'checkDuplicateRequest',

  // â”€â”€ Vendor Profile endpoints â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /getVendors?activeOnly=true — returns all vendor profiles */
  GET_VENDORS: 'getVendors',
  /** POST /addVendor — creates a new vendor profile */
  ADD_VENDOR: 'addVendor',
  /** POST /updateVendor — updates an existing vendor profile */
  UPDATE_VENDOR: 'updateVendor',
  /** POST /toggleVendorStatus — activates or deactivates a vendor */
  TOGGLE_VENDOR_STATUS: 'toggleVendorStatus',
  TOGGLE_VENDOR_USER_STATUS: 'toggleVendorUserStatus',
  /** POST /deleteVendor — hard-deletes a vendor record */
  DELETE_VENDOR: 'deleteVendor',
  CREATE_VENDOR_WORK_ORDER: 'CreateVendorWorkorder'
};

/** Emails automatically CC'd on all vendor communications */
export const VENDOR_AUTO_CC_EMAILS: string[] = [];

